export default __webpack_public_path__ + "static/media/ic-logout.08abecf4.svg";